import { DEFAULT_TIME_12_HOUR_FORMAT, DEFAULT_TIME_24_HOUR_FORMAT, TIMEPICKER_SCROLLABLE_VARIANTS } from './constant';
export const getTimeMaskString = function () {
  let timeFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TIME_12_HOUR_FORMAT;
  if (typeof timeFormat !== 'string') {
    throw new TypeError('timeFormat must be a string');
  }
  return timeFormat.replace(/h/g, '9').replace(/m/g, '9').replace(/T/g, 'a');
};
export const getInputTimeMaskOptions = function () {
  let timeFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TIME_12_HOUR_FORMAT;
  let placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return {
    mask: getTimeMaskString(timeFormat),
    placeholder: placeholder || timeFormat,
    definitions: {
      9: {
        validator: function (chrs, maskset, pos) {
          if (pos === 0) {
            return /^[0-1]$/.test(chrs);
          } else if (pos === 1) {
            if (maskset.buffer[0] === '0') {
              return /^[0-9]$/.test(chrs);
            } else if (maskset.buffer[0] === '1') {
              return /^[0-2]$/.test(chrs);
            }
          } else if (pos === 3) {
            return /^[0-5]$/.test(chrs);
          } else if (pos === 4) {
            return /^[0-9]$/.test(chrs);
          }
          return true;
        },
        cardinality: 1
      },
      a: {
        validator: '[AaPpMm]',
        casing: 'upper',
        cardinality: 1
      }
    },
    insertMode: false
  };
};
export const getTimeMaskString24 = function () {
  let timeFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'HH:MM';
  return timeFormat.replace(/H/g, '9').replace(/M/g, '9');
};
export const getInputTimeMaskOptions24 = function () {
  let timeFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TIME_24_HOUR_FORMAT;
  let placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return {
    mask: getTimeMaskString24(timeFormat),
    placeholder: placeholder || timeFormat,
    definitions: {
      9: {
        validator: function (chrs, maskset, pos) {
          if (pos === 0) {
            return /^[0-2]$/.test(chrs);
          } else if (pos === 1) {
            if (maskset.buffer[0] === '0' || maskset.buffer[0] === '1') {
              return /^[0-9]$/.test(chrs);
            } else if (maskset.buffer[0] === '2') {
              return /^[0-3]$/.test(chrs);
            }
          } else if (pos === 3) {
            return /^[0-5]$/.test(chrs);
          } else if (pos === 4) {
            return /^[0-9]$/.test(chrs);
          }
          return true;
        },
        cardinality: 1
      }
    },
    insertMode: false
  };
};
export function formatTime(time) {
  let is24HourFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const date = new Date(time * 1000);
  let hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  let ampm = '';
  if (!is24HourFormat) {
    ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
  }
  const strHours = hours < 10 ? '0' + hours : hours;
  const strMinutes = minutes < 10 ? '0' + minutes : minutes;
  return {
    hours: strHours || '00',
    minutes: strMinutes || '00',
    ampm: ampm || ''
  };
}
export const normalizeTimeInput = input => {
  const normalizedInput = input.replace(/([0-9])H/, '$10') // Replace H in hours part
  .replace(/H([0-9])/, '0$1') // Replace H in hours part
  .replace(/([0-9])M/, '$10') // Replace M in minutes part
  .replace(/M([0-9])/, '0$1');
  const timeRegex = /^(0?[0-9]|1[0-1]):(0?[0-9]|[1-5][0-9])\s?(AM|PM)$/i;
  if (!timeRegex.test(normalizedInput)) {
    throw new Error('Invalid time format');
  }
  const [, hours, minutes, period] = normalizedInput.match(timeRegex);
  const normalizedHours = hours.padStart(2, '0');
  const normalizedMinutes = minutes.padStart(2, '0');
  const normalizedPeriod = period.toUpperCase();
  return `${normalizedHours}:${normalizedMinutes} ${normalizedPeriod}`;
};
export const convertToSeconds = timeString => {
  const [time, period] = timeString.split(' ');
  let [hours, minutes] = time.split(':').map(Number);
  if (period === 'PM' && hours !== 12) {
    hours += 12;
  }
  if (period === 'AM' && hours === 12) {
    hours = 0;
  }
  return hours * 3600 + minutes * 60;
};
export const getSecondsFromTime = input => {
  const normalizedTime = normalizeTimeInput(input);
  return convertToSeconds(normalizedTime);
};
export const normalizeTimeInput24 = input => {
  const normalizedInput = input.replace(/^([0-9]?)H/, '0$1').replace(/:([0-9]?)M/, ':0$1').replace(/([0-9])H/g, '0$1').replace(/:([0-9])M/g, ':0$1');
  const timeRegex = /^(0?[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/;
  if (!timeRegex.test(normalizedInput)) {
    throw new Error('Invalid time format');
  }
  const [, hours, minutes] = normalizedInput.match(timeRegex);
  const normalizedHours = hours.padStart(2, '0');
  const normalizedMinutes = minutes.padStart(2, '0');
  return `${normalizedHours}:${normalizedMinutes}`;
};
export const convertToSeconds24 = timeString => {
  const [hours, minutes] = timeString.split(':').map(Number);
  return hours * 3600 + minutes * 60;
};
export const getSecondsFromTime24 = input => {
  const normalizedTime = normalizeTimeInput24(input);
  return convertToSeconds24(normalizedTime);
};
const updateHour = (time, selectedValue, updateValue) => {
  if (updateValue > selectedValue) {
    return time + (updateValue - selectedValue) * 3600;
  }
  return time - (selectedValue - updateValue) * 3600;
};
const updateMinute = (time, selectedValue, updateValue) => {
  if (updateValue > selectedValue) {
    return time + (updateValue - selectedValue) * 60;
  }
  return time - (selectedValue - updateValue) * 60;
};
const updateAMPM = (time, updateValue) => {
  if (updateValue === 'AM') {
    return time + 12 * 3600;
  }
  return time - 12 * 3600;
};
export const updateTime = (time, selectedValue, updateValue, type) => {
  switch (type) {
    case TIMEPICKER_SCROLLABLE_VARIANTS.HOURS:
      return updateHour(time, selectedValue, updateValue);
    case TIMEPICKER_SCROLLABLE_VARIANTS.MINUTES:
      return updateMinute(time, selectedValue, updateValue);
    case TIMEPICKER_SCROLLABLE_VARIANTS.AM_PM:
      return updateAMPM(time, updateValue);
    default:
      return time;
  }
};
export const getFormattedCurrentTime = function () {
  let minuteInterval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  const now = new Date();
  let hours = now.getHours();
  const minutes = now.getMinutes();
  const period = hours >= 12 ? 'PM' : 'AM';
  if (hours === 0) {
    hours = 12;
  } else if (hours > 12) {
    hours = hours - 12;
  }
  const adjustedMinutes = Math.floor(minutes / minuteInterval) * minuteInterval;
  let totalSeconds = 0;
  if (period === 'AM') {
    totalSeconds = hours % 12 * 3600 + adjustedMinutes * 60; // Midnight to Noon
  } else {
    totalSeconds = (hours % 12 + 12) * 3600 + adjustedMinutes * 60; // Noon to Midnight
  }
  return totalSeconds;
};
export const formattedTime = (time, is24HourFormat) => {
  const timeObject = formatTime(time, is24HourFormat) || {
    hours: 0,
    minutes: 0,
    ampm: 'AM'
  };
  const formattedTime = is24HourFormat ? `${timeObject.hours}:${timeObject.minutes}` : `${timeObject.hours}:${timeObject.minutes} ${timeObject.ampm}`;
  return formattedTime;
};